import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';
import { getNewAddress } from './utils';

export function ServiceType() {
  const { watch, setValue, control } = useFormContext<IForm>();

  const { line } = useFormDataContext();

  const { t } = useAppTranslation(['common', 'demand']);

  const addresses = watch('stops');

  if (!line) return null;
  return (
    <Controller
      control={control}
      name="service_type_id"
      rules={{
        required: t('common:msg.required_field'),
      }}
      render={({ field, fieldState: { error } }) => (
        <WrappedSelect
          isOnModal
          id="serviceType"
          {...field}
          label={t('common:service', {
            count: 1,
          })}
          requiredMark
          onChange={(e) => {
            const serviceTypeId = e.target.value;
            const selectedServiceType = line?.service_types.find(
              ({ id }) => id.toString() === serviceTypeId.toString()
            );
            const cargoTypes = selectedServiceType?.cargo_types.filter(
              ({ vehicle_types }) => !!vehicle_types.length
            );
            if (selectedServiceType?.modalities.length === 1) {
              const modality = selectedServiceType?.modalities.at(0);
              setValue('modality_id', modality?.id);
              setValue('stops', [
                addresses.at(0) ?? getNewAddress(),
                ...(modality?.single_address
                  ? []
                  : [addresses.at(1) ?? getNewAddress()]),
              ]);
            }
            if (cargoTypes?.length === 1) {
              setValue('cargo_type_id', cargoTypes.at(0)?.id);
            }
            field.onChange(serviceTypeId);
          }}
          error={error?.message}
          className=""
        >
          <option hidden value="">
            {t('common:select_option')}
          </option>
          {line?.service_types.map(({ id, name, for_offer }) => {
            if (!for_offer) return;
            return (
              <option key={id} value={id}>
                {name}
              </option>
            );
          })}
        </WrappedSelect>
      )}
    />
  );
}
